module.exports = __webpack_public_path__ + "img/wein-natur-mobil.06c141a6.jpg";